import React from 'react';
import { Button } from './ui/button';
import { contactData } from '../data/mockData';
import { 
  Mail, 
  Phone, 
  MapPin, 
  Instagram, 
  ArrowUp,
  Building2,
  Hammer,
  Lightbulb,
  Users
} from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const currentYear = new Date().getFullYear();

  const services = [
    { name: "Stands para Feiras", icon: Building2 },
    { name: "Quiosques & PDVs", icon: Hammer },
    { name: "Ambientações", icon: Lightbulb },
    { name: "Cenografias", icon: Users }
  ];

  const quickLinks = [
    { name: "Início", href: "#home" },
    { name: "Portfólio", href: "#portfolio" },
    { name: "Processo", href: "#processo" },
    { name: "Sobre", href: "#sobre" },
    { name: "Contato", href: "#contato" }
  ];

  return (
    <footer className="bg-gray-900 text-white relative">
      {/* Back to Top Button */}
      <button
        onClick={scrollToTop}
        className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-[#FF1616] rounded-full flex items-center justify-center hover:bg-red-700 transition-all duration-300 shadow-lg hover:shadow-xl"
      >
        <ArrowUp className="w-5 h-5 text-white" />
      </button>

      <div className="mx-auto w-full max-w-7xl px-4 pt-16 pb-8">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            {/* Logo Forttana */}
            <div className="flex items-center space-x-3 mb-4">
              <div className="relative">
             <img
          src="/assets/images/logo-forttana.png"
            alt="Forttana Eventos"
            width="42"
              height="42"
                className="object-contain"
                  />
              </div>
              <div className="text-xl font-black tracking-wider">
                <span className="text-white font-empresa">FORTTANA</span>
                <div className="text-xs font-medium text-gray-400 -mt-1 tracking-[0.3em] font-empresa">EVENTOS</div>
              </div>
            </div>
            
            <p className="text-gray-300 mb-6 leading-relaxed">
              Há mais de 10 anos criando experiências extraordinárias. 
              <strong> Stands, quiosques, ambientações e cenografias</strong> que impressionam e geram resultados.
            </p>

            {/* Social Media */}
            <div className="flex space-x-4">
              <Button 
                size="sm" 
                variant="outline" 
                className="w-10 h-10 p-0 border-gray-600 text-gray-300 hover:border-[#FF1616] hover:text-[#FF1616] hover:bg-transparent"
                onClick={() => window.open('https://instagram.com/forttana_eventos', '_blank')}
              >
                <Instagram className="w-4 h-4" />
              </Button>
              <Button 
                size="sm" 
                variant="outline" 
                className="w-10 h-10 p-0 border-gray-600 text-gray-300 hover:border-[#FF1616] hover:text-[#FF1616] hover:bg-transparent"
                onClick={() => window.open(`https://wa.me/${contactData.whatsapp}`, '_blank')}
              >
                <Phone className="w-4 h-4" />
              </Button>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-black mb-6 text-white tracking-wide">NOSSOS SERVIÇOS</h3>
            <ul className="space-y-3">
              {services.map((service) => {
                const IconComponent = service.icon;
                return (
                  <li key={service.name} className="flex items-center text-gray-300 hover:text-[#FF1616] transition-colors cursor-pointer">
                    <IconComponent className="w-4 h-4 mr-3 text-[#FF1616]" />
                    {service.name}
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-black mb-6 text-white tracking-wide">LINKS RÁPIDOS</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-300 hover:text-[#FF1616] transition-colors duration-200 font-medium"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-black mb-6 text-white tracking-wide">CONTATO</h3>
            <div className="space-y-4">
              <div className="flex items-center text-gray-300">
                <Mail className="w-4 h-4 mr-3 text-[#FF1616]" />
                <span className="text-sm">{contactData.email}</span>
              </div>
              
              <div className="flex items-center text-gray-300">
                <Phone className="w-4 h-4 mr-3 text-[#FF1616]" />
                <span className="text-sm">{contactData.phone}</span>
              </div>
              
              <div className="flex items-center text-gray-300">
                <MapPin className="w-4 h-4 mr-3 text-[#FF1616]" />
                <span className="text-sm">{contactData.address}</span>
              </div>
            </div>

            {/* CTA Button */}
            <Button 
              className="mt-6 bg-[#FF1616] hover:bg-red-700 text-white w-full font-bold tracking-wide"
              onClick={() => window.open(`https://wa.me/${contactData.whatsapp}`, '_blank')}
            >
              FALE CONOSCO
            </Button>
          </div>
        </div>

        {/* Newsletter */}
        <div className="border-t border-gray-800 pt-8 mb-8">
          <div className="text-center">
            <h3 className="text-xl font-black mb-3 text-white tracking-wide">
              RECEBA NOVIDADES & INSPIRAÇÕES
            </h3>
            <p className="text-gray-400 mb-6">
              Cadastre-se para receber tendências em design de stands e ofertas exclusivas
            </p>
            <div className="flex max-w-md mx-auto">
              <input
                type="email"
                placeholder="Seu melhor email"
                className="h-12 flex-1 px-4 py-3 bg-gray-800 border border-gray-700 rounded-l-lg text-white placeholder-gray-400 focus:outline-none focus:border-[#FF1616]"
              />
              <Button className="h-12 bg-[#FF1616] hover:bg-red-700 text-white px-6 rounded-l-none font-bold tracking-wide">
                CADASTRAR
              </Button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-6 flex flex-col md:flex-row justify-between items-center text-gray-400 text-sm">
          <div className="font-medium">
            © {currentYear} Forttana Eventos. Todos os direitos reservados.
          </div>
          
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="hover:text-[#FF1616] transition-colors">
              Política de Privacidade
            </a>
            <a href="#" className="hover:text-[#FF1616] transition-colors">
              Termos de Uso
            </a>
            <a href={contactData.website} className="hover:text-[#FF1616] transition-colors">
              {contactData.website}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
